import classNames from "classnames";
import React, { ReactNode } from "react";

import "./AnyaAgentsState.less";

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  variant?: "default" | "muted" | "error";
  icon?: ReactNode;
  actions?: ReactNode;
};

export default function AnyaAgentsState({
  title,
  description,
  variant = "default",
  icon,
  actions,
}: Props) {
  return (
    <div
      className={classNames(
        "anya-agents-state",
        "d-flex flex-column align-items-center justify-content-center text-center gap-10",
        {
          "anya-agents-state--muted": variant === "muted",
          "anya-agents-state--error": variant === "error",
        },
      )}
    >
      {icon}
      {title ? (
        <div className="text-large-highlight color-highlight">{title}</div>
      ) : null}
      {description ? (
        <div className="text-supporting">{description}</div>
      ) : null}
      {actions}
    </div>
  );
}
